import { Content } from "./components/content/content";

import { AccountCreationContextProvider } from "./hooks/account-creation-context";
import { ReactNode } from "react";

export const AccountCreation = ({
    getContinueUrl,
    identityCobranding,
    templateId,
    ...props
}: {
    getContinueUrl?: () => string | undefined;
    identityCobranding?: string;
    templateId?: string;
    Error?: ReactNode;
    Input?: ReactNode;
    Login?: ReactNode;
    Separator?: ReactNode;
    Social?: ReactNode;
    Submit?: ReactNode;
}) => (
    <AccountCreationContextProvider
        getContinueUrl={getContinueUrl}
        identityCobranding={identityCobranding}
        templateId={templateId}
    >
        <Content {...props} />
    </AccountCreationContextProvider>
);
